import { getAvailableServicesForInterventionReportByFileId } from './getAvailableServicesForInterventionReportByFileId';
import getInterventionReport from './getInterventionReport';
import getInterventionReportQuery from './getInterventionReportQuery';
import { getIrisCode } from './getIrisCode';
import getLastCreatedQuotationByFileIdQuery from './getLastCreatedQuotationByFileIdQuery';
import getPendingCustomerValidationByFileId from './getPendingCustomerValidationByFileId';
import getPossibleRecipientTypesByFileIdQuery from './getPossibleRecipientTypesByFileIdQuery';
import { getQuotationsByFileIdQuery } from './getQuotationsByFileIdQuery';
import { getTechnicalInterventionStatesBySellerQuery } from './getTechnicalInterventionStatesBySellerQuery';
import { setInterventionReport } from './interventionReport/setInterventionReport/setInterventionReport';
import setInterventionReportExtended from './interventionReport/setInterventionReport/setInterventionReportExtended';
import { setQuoteClientAnswerCommand } from './setQuoteClientAnswerCommand';
import { updateQuotationSparePartSelectionCommand } from './updateQuotationSparePartSelectionCommand';
import { uploadInterventionReportSignatureCommand } from './uploadInterventionReportSignatureCommand';
import { upsertTechnicalInterventionStatesBySellerCommand } from './upsertTechnicalInterventionStatesBySellerCommand';

export const CommonRepairerService = {
  getQuotationsByFileIdQuery,
  getAvailableServicesForInterventionReportByFileId,
  setQuoteClientAnswerCommand,
  updateQuotationSparePartSelectionCommand,
  getPendingCustomerValidationByFileId,
  getIrisCode,
  getInterventionReport,
  getInterventionReportQuery,
  getLastCreatedQuotationByFileIdQuery,
  setInterventionReportExtended,
  setInterventionReport,
  getPossibleRecipientTypesByFileIdQuery,
  uploadInterventionReportSignatureCommand,
  getTechnicalInterventionStatesBySellerQuery,
  upsertTechnicalInterventionStatesBySellerCommand,
};
